"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FeaturesSection = _interopRequireDefault(require("pricing-pages-unified-ui/components/free-tools-page/FeaturesSection"));

var _GuaranteeSection = _interopRequireDefault(require("pricing-pages-unified-ui/components/free-tools-page/GuaranteeSection"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _FooterMicrocopy = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/FooterMicrocopy"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _Question = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Question"));

var _reactRouterDom = require("react-router-dom");

var _reactRhumb = require("react-rhumb");

var _TabLayout = _interopRequireDefault(require("../tabs/TabLayout"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _EnvironmentWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/EnvironmentWrapper"));

var _SignupButton = _interopRequireDefault(require("pricing-pages-unified-ui/components/public-only/SignupButton"));

var _DocumentUtils = require("pricing-pages-unified-ui/utils/DocumentUtils");

var _PhoneSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupport"));

var _colors = require("HubStyleTokens/colors");

var _SkeletonLoadWrapper = _interopRequireDefault(require("../loading/SkeletonLoadWrapper"));

var _LoadingStateSelectors = require("../../selectors/LoadingStateSelectors");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 90%;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 0.45em;\n    text-align: left;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      text-align: left;\n      margin-bottom: .93em;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 1em;\n    margin-top: 3.1em;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n    margin-top: 0;\n    background-color: ", ";\n    padding-bottom: 3.4em;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "FreeToolsPage__Container",
  componentId: "sc-8txlg3-0"
})(["background-color:white;display:flex;align-items:center;flex-direction:column;overflow:hidden;width:100%;position:relative;"]);

var MainHeader = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "FreeToolsPage__MainHeader",
  componentId: "sc-8txlg3-1"
})(["text-align:center;font-weight:600;font-size:32px;margin-bottom:20px;line-height:40px;@media (max-width:", "px){font-size:29px;}"], _Breakpoints.FEATURES_SECTION);
var SubHeader = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "FreeToolsPage__SubHeader",
  componentId: "sc-8txlg3-2"
})(["font-weight:300;font-size:14px;text-align:center;max-width:600px;@media (max-width:", "px){font-size:16px;}"], _Breakpoints.FEATURES_SECTION);

var PhoneSupportWrapper = _styledComponents.default.div.withConfig({
  displayName: "FreeToolsPage__PhoneSupportWrapper",
  componentId: "sc-8txlg3-3"
})(["width:450px;margin-top:40px;", ""], _responsiveBreakpoints.default.phone(_templateObject(), _colors.GYPSUM));

var FaqContainer = _styledComponents.default.div.withConfig({
  displayName: "FreeToolsPage__FaqContainer",
  componentId: "sc-8txlg3-4"
})(["width:950px;margin-right:auto;margin-left:auto;padding-top:40px;clear:both;", " ", ";.faq-header{text-align:center;", "}"], _responsiveBreakpoints.default.tablet(_templateObject2()), _responsiveBreakpoints.default.phone(_templateObject3()), _responsiveBreakpoints.default.phone(_templateObject4()));

var Taglines = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "FreeToolsPage__Taglines",
  componentId: "sc-8txlg3-5"
})(["text-align:center;margin:1.55em 0 0.74em;", " .tagline{display:block;}"], _responsiveBreakpoints.default.phone(_templateObject5()));

var SignupButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "FreeToolsPage__SignupButtonWrapper",
  componentId: "sc-8txlg3-6"
})(["", ""], _responsiveBreakpoints.default.phone(_templateObject6()));

var FreeToolsPage = function FreeToolsPage() {
  (0, _react.useEffect)(function () {
    (0, _getUsageTracker.default)().track('pageView', {
      screen: _Tracking.SCREENS.PRODUCTS_PLANS,
      subscreen: _Tracking.SUBSCREENS.FREE_TOOLS_CRM
    });
  }, []);
  var hasPricingAndPurchasingSucceeded = (0, _reactRedux.useSelector)(_LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector);
  return _react.default.createElement(_TabLayout.default, {
    selectedPrimaryTab: "products",
    selectedSecondaryTab: "crm"
  }, _react.default.createElement(Container, {
    "data-selenium-id": "page-success"
  }, _react.default.createElement(_reactRhumb.NavMarker, {
    name: "FREE_TOOLS_PAGE"
  }), _react.default.createElement("div", {
    className: "display-flex align-center flex-column p-x-4",
    style: {
      maxWidth: '800px',
      paddingTop: '50px',
      paddingBottom: '50px'
    }
  }, _react.default.createElement(MainHeader, {
    message: 'pricingPage.pages.crm.mainHeader'
  }), _react.default.createElement(SubHeader, {
    message: 'pricingPage.pages.crm.subHeader'
  }), _react.default.createElement(_EnvironmentWrapper.default, {
    publicNode: _react.default.createElement(_SkeletonLoadWrapper.default, {
      widths: [200],
      heights: [56],
      className: "m-top-5",
      isLoading: !hasPricingAndPurchasingSucceeded
    }, _react.default.createElement(_SignupButton.default, {
      sourceId: "crm-pricing-hero",
      className: "p-x-9 p-y-5 m-top-5",
      ctaKey: 'pricingPage.signupCtas.getStartedFree'
    }))
  })), _react.default.createElement(_FeaturesSection.default, null), _react.default.createElement(_GuaranteeSection.default, null), _react.default.createElement(PhoneSupportWrapper, null, _react.default.createElement(_PhoneSupport.default, {
    phoneSourceId: "crm-middle",
    screen: _Tracking.SUBSCREENS.FREE_TOOLS_CRM
  })), _react.default.createElement(FaqContainer, null, _react.default.createElement(_H.default, {
    className: "faq-header"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.faq.title"
  })), _react.default.createElement(_Question.default, {
    questionKey: "free.crmReallyFree"
  }), _react.default.createElement(_Question.default, {
    questionKey: "free.crmIntegrateEmail"
  }), _react.default.createElement(_Question.default, {
    questionKey: "free.crmAvailableSupport",
    href: (0, _urls.getCommunityUrl)()
  }), _react.default.createElement(_Question.default, {
    questionKey: "free.crmUserCountAndDefinition"
  })), _react.default.createElement(_FooterMicrocopy.default, null), _react.default.createElement(_EnvironmentWrapper.default, {
    publicNode: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Taglines, null, _react.default.createElement(_FormattedMessage.default, {
      className: "tagline",
      message: "pricingPage.pages.crm.mainHeader"
    })), _react.default.createElement(SignupButtonWrapper, null, _react.default.createElement(_SkeletonLoadWrapper.default, {
      widths: [200],
      heights: [56],
      className: "m-bottom-8",
      isLoading: !hasPricingAndPurchasingSucceeded
    }, _react.default.createElement(_SignupButton.default, {
      sourceId: "crm-pricing-bottom",
      className: "p-x-9 p-y-5 m-top-5 m-bottom-8",
      ctaKey: 'pricingPage.signupCtas.getStartedFree'
    }))))
  })));
};

var _default = (0, _reactRouterDom.withRouter)((0, _DocumentUtils.withDocumentTitle)(FreeToolsPage, 'free'));

exports.default = _default;
module.exports = exports.default;